export const getApiUrl = (url: string) => `/api${url}`;
